<template>
  <div> 
    <ibs-form ref="CreateForm" mode="create" :action="onRefresh"/>
    <ibs-form ref="UpdateForm" mode="update" :action="onRefresh"/>
    <ibs-form ref="CopyForm" mode="copy" :action="onRefresh"/>
    <ibs-form ref="DeleteForm" mode="delete" :action="onRefresh"/>

<md-card class="searchPanel">
  <md-card-content v-if="searchRequest">

    <md-dialog :md-active.sync="isFilterModalShowing" >
      
      <div> 
       <md-dialog-title>Filter</md-dialog-title>
       <div class="custButtonFilterRight"> 
         <md-button class="custButtonFilter md-primary md-raised " @click="doSearch">Search</md-button> 
         <md-button class="custButtonFilter md-raised " @click="isFilterModalShowing = false" >Close</md-button>
        </div>
       </div>

     <md-dialog-content>

      <div class = "inputBoxDouble" >
        <div class = "inputBoxSpace" >
          <datepicker v-model="searchRequest.po_lsd.startDate">
            <label>PO Last delivery date</label>
          </datepicker>
        </div>
      
        <div class = "inputBoxSpace" >
          <datepicker v-model="searchRequest.po_lsd.endDate">
            <label>To</label>
          </datepicker>
        </div>
      </div>


      <div class = "inputBoxDouble" >

        <div class = "inputBoxSpace" >
           <md-field>
              <label>Weight Ticket</label>
              <md-input v-model.trim="searchRequest.scaleTicket"/>
          </md-field>
        </div>
           
        <div class = "inputBoxSpace" >
           <md-field>
              <label>Driver</label>
              <md-input v-model="searchRequest.moveInBy"/>
          </md-field>
        </div>

      </div>

      <div class = "inputBoxDouble" >

        <div class = "inputBoxSpace" >
           <md-field>
              <label>Supplier</label>
              <md-input v-model.trim="searchRequest.supplier_name"/>
          </md-field>
        </div>
           
        <div class = "inputBoxSpace" >
           <md-field>
              <label>BOL</label>
              <md-input v-model.trim="searchRequest.bol"/>
          </md-field>
        </div>

      </div>

      <div class = "inputBoxDouble" >

        <div class = "inputBoxSpace" >
           <md-field>
              <label>Trucker Name</label>
              <md-input v-model.trim="searchRequest.trucker_name"/>
          </md-field>
        </div>
           
        <div class = "inputBoxSpace" >
           <md-field>
              <label>Material</label>
              <md-input v-model.trim="searchRequest.matnr_desc"/>
          </md-field>
        </div>

      </div>

      <div class = "inputBoxDouble" >

        <div class = "inputBoxSpace" >
           <md-field>
              <label>QC Issue</label>
              <md-input v-model.trim="searchRequest.qcIssue"/>
          </md-field>
        </div>
           
        <div class = "inputBoxSpace" >
            <datepicker v-model="searchRequest.ciDate">
              <label>Check In Date</label>
            </datepicker>
          
        </div>
      </div>

       <!--<div class = "inputBoxDouble" >-->

          <div class = "inputBoxSpace" >
             <md-field>
                <label>Weight Different</label>
                <md-input v-model="searchRequest.weightDifferent"/>
            </md-field>
          </div>
             
        
<!--
        <div class = "inputBoxSpace" >
          <auto-complete-master-data-select
                                              group="REC_WINDOW"
                                              label="Rev. Windows"
                                              :init-value="searchRequest.receivingWindows"
                                              :on-item-changed="handleWindowsChanged"
                                              >
          </auto-complete-master-data-select>
        </div>
      -->
      <!--</div>-->


     </md-dialog-content>
    </md-dialog>


      <div class="md-layout md-gutter">

        <div v-if="active" >
          <div class="result-included-outter-div">
            <div class="result-included-inner-div-radio">
              <span class="result-included-span-radio"> 
              ApptDate: 
              </span>
              <md-radio v-model="selectapptDate" value="apptDate_null"  @change="onSelectappt" >Only empty apptDate</md-radio>
              <md-radio v-model="selectapptDate" value="apptDate"  @change="onSelectappt" >All apptDate</md-radio>  
          </div>
        
        </div> 
      </div> 


        <div v-if="active" >
          <div class="result-included-outter-div">
            <div class="result-included-inner-div">
              SAP status:  
            </div>
        <div class="result-included-div-span">
        <span>
          <md-checkbox v-model="filtersapStatus_x"><label>Already sent</label></md-checkbox> 
        </span>
        <span class="result-included-span"> 
          <md-checkbox v-model="filtersapStatus_null"><label>Not yet</label></md-checkbox>
        </span>
        </div>
        </div> 
      </div>
    </div>
      <div class="md-layout md-gutter">

        <div  v-if="active" class="md-layout-item md-size-20 md-small-size-30">
          <div ref = "refapptDateF" class = "inputBox">
              <auto-complete-master-data-select
                  label="Rec Window"
                  :prepared-options="recWindows"
                  :init-value-id="searchRequest.receivingWindows"
                  :on-item-changed="handleRecWindowChanged"
              />
          </div>    
        </div>

        <div  v-if="active" class="md-layout-item md-size-20 md-small-size-30">
          <div ref = "refapptDateF" class = "inputBox">
            <datepicker v-model="searchRequest.apptDate.startDate">
              <label>Appt date</label>
            </datepicker>
          </div>
        </div>

        <div  v-if="active" class="md-layout-item md-size-20 md-small-size-30">
          <div ref = "refapptDateT" class = "inputBox">
            <datepicker v-model="searchRequest.apptDate.endDate">
              <label>To</label>
            </datepicker>
          </div>
        </div>

        <div v-if="active" class="md-layout-item md-size-20 md-small-size-30">
          <div class = "inputBox">
          <md-field>
            <label>IBS</label>
            <md-input v-model.trim="searchRequest.ibs"/>
          </md-field>
          </div>
        </div>

        <div v-if="active" class="md-layout-item md-size-20 md-small-size-30">
          <div class = "inputBox">
          <md-field>
            <label>IBD</label>
            <md-input v-model.trim="searchRequest.ibd"/>
          </md-field>
          </div>
        </div>

        <div v-if="active" class="md-layout-item md-size-20 md-small-size-30">
          <div class = "inputBox">
          <md-field>
            <label>PO</label>
            <md-input v-model.trim="searchRequest.po"/>
          </md-field>
          </div>
        </div>

        <div v-if="active" class="md-layout-item md-size-20 md-small-size-30">
          <div ref = "refibsprocessDateF" class = "inputBox">
            <datepicker v-model="searchRequest.ibs_process_DT.startDate">
              <label>IBS process date</label>
            </datepicker>
          </div>
        </div>

        <div v-if="active" class="md-layout-item md-size-20 md-small-size-30">
          <div ref = "refibsprocessDateT"  class = "inputBox">
            <datepicker v-model="searchRequest.ibs_process_DT.endDate">
              <label>To</label>
            </datepicker>
          </div>
        </div>

        <div v-if="active" class="md-layout-item md-size-20 md-small-size-30">
        <div class = "inputBox" >
          <auto-complete-master-data-multiple-select
                                             group="IBS_TYPE"
                                             label="IBS Type"
                                             v-model="searchRequest.ibs_types">
        </auto-complete-master-data-multiple-select>
       </div>
      </div>  

      <div v-if="active" class="md-layout-item md-size-20 md-small-size-30">
        <div class = "inputBox">
          <auto-complete-master-data-select
                                      group="INBOUND_STATUS"
                                      label="Inbound Status"
                                      :init-value="searchRequest.inboundStatus"
                                      :on-item-changed="handleStatusChanged"
          >
          </auto-complete-master-data-select>
        </div>
      </div>
    
    <div
      v-if="active"
      class="md-layout-item md-size-20 md-small-size-30">
      <div class = "inputBox" >
        <auto-complete-master-data-select
                                          group="DOCKTYPE"
                                          label="Dock Type"
                                          :init-value="searchRequest.dockType"
                                          :on-item-changed="handleDockChanged"
                                          >
      </auto-complete-master-data-select>
      </div>
    </div>  
   
     </div>   
   </md-card-content>   

   <md-card-actions md-alignment="space-between">
    <!--<div v-if="getPermission.ibslist.edit" class="md-layout-item md-size-100 md-small-size-100">-->
      <div v-if="getPermission.ibslist3p.view" class="md-layout-item md-size-100 md-small-size-100">  
      <callingApiCenter :paths="['/api/w/fsi/WebUploadNonfsiibs']">
          <callingApiCenter :paths="['/api/w/fsi/GetIBSInbound','/api/w/fsi/GetIBSInboundNew']" :not-display-error="true">      
             <input v-if="getPermission.ibslist3p.edit" type="file" class="md-hide" id="upload-load-list" accept=".xls,.xlsx" @change="handleUploadApplicationFileSelected"/>           
             <md-button v-if="getPermission.ibslist3p.edit" class="md-raised custMenuButton " @click="doIBSCreate" :disabled="(this.getPermission.fsireadonly.view && !this.getPermission.fsireadonly.edit) || this.getPermission.fsireadonlywithwgtticket.view || this.getPermission.stcAcct.view || this.getPermission.stcloadlistupdate.view"><span class="icons-center material-icons">create</span>New</md-button>
             <!--
             <md-button class="md-raised custButton " @click="doIBSUpdate" :disabled="(this.getPermission.fsireadonly.view && !this.getPermission.fsireadonly.edit) || this.getPermission.fsireadonlywithwgtticket.view || this.getPermission.stcAcct.view || this.getPermission.stcloadlistupdate.view"><span class="icons-center material-icons">create</span>Update</md-button>
             <md-button class="md-raised custButton " @click="doIBSCopy" :disabled="(this.getPermission.fsireadonly.view && !this.getPermission.fsireadonly.edit) || this.getPermission.fsireadonlywithwgtticket.view || this.getPermission.stcAcct.view || this.getPermission.stcloadlistupdate.view"><span class="icons-center material-icons">create</span>Copy</md-button>
             <md-button class="md-raised custButton " @click="doIBSDelete" :disabled="(this.getPermission.fsireadonly.view && !this.getPermission.fsireadonly.edit) || this.getPermission.fsireadonlywithwgtticket.view || this.getPermission.stcAcct.view || this.getPermission.stcloadlistupdate.view"><span class="icons-center material-icons">create</span>Delete</md-button>
             -->
             <div class="dropdown" v-if="getPermission.ibslist3p.edit">
                   <md-button class="md-raised custMenuButton " @click="doDropDown('edit')" >Edit...  <span class="icons-center material-icons">add</span></md-button>                
             </div> 
             <md-button class="md-raised custMenuButton" @click="filterBar"> Filter </md-button>
             <md-button class="custMenuButton md-raised" @click="doDownloadExcel" :disabled="!getDownloadCond"> Download </md-button>
             <md-button v-if="getPermission.ibslist3p.edit" class="md-raised custMenuButton" @click="doUpload">Upload</md-button>
             <input
             class="custSearchBar"
             type="text"
             placeholder="Searching Term"
             v-model="searchtermFilter"
             />

             <div class="custButtonRight">
              <md-button class="md-raised custMenuButton md-primary" @click="doSearch">Search</md-button>
              <md-button class="md-raised custMenuButton" @click="doClear">Clear</md-button>
              <md-button class="md-icon-button" @click="mouseLeave" id="expand-button">
                <md-icon v-if="active == false">keyboard_arrow_down</md-icon>
                <md-icon v-if="active == true">keyboard_arrow_up</md-icon>
               </md-button>
             </div>

          </callingApiCenter>
        </callingApiCenter>
      </div>
  </md-card-actions>
    

 
</md-card>

<pagination :items="getibsToDisplay">
  <template slot-scope="{pageItems}">
    <md-card class="data-table-container">
      <div class="outer-container">
        <div class="inner-container">
          <div class="table-header">
            <table id="headertable">
              <thead>
                <th ></th>
                <th class="header-cell w2"></th>
              <th class="header-cell headerCenter w5"
                @click="sortFunction('ibs_type')">IBS type</th>

              <th class="header-cell headerCenter w6"
                @click="sortFunction('trans_yard')">Trans. Yard</th>

              <th class="header-cell center w5"
              @click="sortFunction('apptDate')">Appointment Date</th>

              <th class="header-cell center w5"
              @click="sortFunction('apptDate')">Appointment Time</th>

              <th class="header-cell headerCenter w5"
              @click="sortFunction('ibs')">IBS</th>

              <th class="header-cell headerCenter w5"
              @click="sortFunction('ibd')">IBD</th>

              <th class="header-cell headerCenter w5"
              @click="sortFunction('po')">PO</th>

              <th class="header-cell headerCenter w5"
              @click="sortFunction('trucker')">Truck ID</th>

              <th class="header-cell headerCenter w10"
              @click="sortFunction('truck_name')">Truck name</th>

              <th class="header-cell headerCenter w6"  
              v-on:click ="sortFunction('po_lsd')">Po Last delivery Date</th>

              <th class="header-cell headerCenter w5"
              @click="sortFunction('inco1')">Incoterms</th>

              <th class="header-cell headerCenter w5"
              @click="sortFunction('ac')">AC</th>

              <th class="header-cell center w5"
              v-on:click="sortFunction('ac_name')">AC name</th>

              <th class="header-cell headerCenter w5" 
                @click="sortFunction('ibs_status')">IBS status</th>

              <th class="header-cell headerCenter w5"
              @click="sortFunction('matnr')">Material</th>

              <th class="header-cell center w5"
              v-on:click="sortFunction('matnr_desc')">Material Desc</th>

              <th class="header-cell headerCenter w5"
              @click="sortFunction('supplier')">Supplier ID</th>

              <th class="header-cell headerCenter w10"
              @click="sortFunction('supplier_name')">Supplier Name</th>
              
              <th class="header-cell center w5"
              v-on:click="sortFunction('route')">Route</th>
            
              <th class="header-cell center w7"
              v-on:click="sortFunction('route_desc')">Route Desc</th>

              <th class="header-cell headerCenter w6"
              @click="sortFunction('ibs_process_DT')">Created on</th>                  

              <th class="header-cell headerCenter w5"
              @click="sortFunction('ibs_process_TIME')">Created time</th>

              <th class="header-cell headerCenter w5"
              @click="sortFunction('transloadingYard')">Transloading Yard</th>

              <th class="header-cell headerCenter w5"
              @click="sortFunction('receivingWindows')">Receiving Windows</th>

              <th class="header-cell center w5"
              @click="sortFunction('dockType')">Dock Type</th>

              <th class="header-cell center w5"
              @click="sortFunction('dockType')">IBS Dock Type</th>

              <th class="header-cell center w5"
              @click="sortFunction('dockType')">Spot Type</th>

              <th class="header-cell center w5"
              @click="sortFunction('apptNo')">Appointment No.</th>

              <th class="header-cell center w5"
              @click="sortFunction('inboundStatus')">Inbound Status</th>

              <th class="header-cell center w3"
              @click="sortFunction('block')">Block</th>

              <th class="header-cell center w5"
              v-on:click="sortFunction('workIn')">Work In</th>
              
              <th class="header-cell center w8"
              v-on:click="sortFunction('externalTrucker')">External Trucker</th>

              <th
              class="header-cell center w6"
              v-on:click="sortFunction('moveInBy')">
              Driver
            </th>
            <th
              class="header-cell center w5"
              v-on:click="sortFunction('driverPh')">
              Driver Phone Number
            </th>
            <th
              class="header-cell center w5"
              v-on:click="sortFunction('driverLP')">
              License Plate#
            </th>
            <th
              class="header-cell center w5"
              v-on:click="sortFunction('containerNo')">
              Trailer#
            </th>
            
            <th
              class="header-cell center w5"
              v-on:click="sortFunction('ciDate')">
              CI Date
            </th>
            <th
              class="header-cell center w5"
              v-on:click="sortFunction('ciDate')">
              CI Time
            </th>
            <th
              class="header-cell center w5"
              v-on:click="sortFunction('scaleCalled')">
              Scale Called
            </th>
            <th
              class="header-cell center w5"
              v-on:click="sortFunction('callTime')">
              Call Time
            </th>
            <th
              class="header-cell center w5"
              v-on:click="sortFunction('gwStation')">
              GW Station
            </th>
            <th
              class="header-cell center w7"
              v-on:click="sortFunction('scaleTicket')">
              Weight Ticket
            </th>
            <th
              class="header-cell center w7"
              v-on:click="sortFunction('scanWt')">
              Scan Weight Ticket
            </th>

            <th
              class="header-cell center w7">
              Ticket to SAP
            </th>

            <th
              class="header-cell center w5"
              v-on:click="sortFunction('vgmWeight')">
              Gross Weight
            </th>
   
            <th
              class="header-cell center w5"
              v-on:click="sortFunction('gwDate')">
              GW Date
            </th>

            <th
              class="header-cell center w5"
              v-on:click="sortFunction('gwDate')">
              GW Time
            </th>

            <th
              class="header-cell center w5"
              v-on:click="sortFunction('gwDateWeb')">
              GW Date Web
            </th>

            <th
              class="header-cell center w5"
              v-on:click="sortFunction('gwDateWeb')">
              GW Time Web
            </th>
            <th
              class="header-cell center w5"
              v-on:click="sortFunction('gwYgNo')">
              GW-YG No.
            </th>
            <th
              class="header-cell center w5"
              v-on:click="sortFunction('gwYgWeight')">
              GW-YG Weight
            </th>
            <th
              class="header-cell center w5"
              v-on:click="sortFunction('twStation')">
              TW Station
            </th>
            <th
              class="header-cell center w5"
              v-on:click="sortFunction('tareWeight')">
              Tare Weight
            </th>

            <th
              class="header-cell center w5"
              v-on:click="sortFunction('twDate')">
              TW Date
            </th>
            <th
              class="header-cell center w5"
              v-on:click="sortFunction('twDate')">
              TW Time
            </th>
            <th
              class="header-cell center w5"
              v-on:click="sortFunction('twDateWeb')">
              TW Date Web
            </th>
            <th
              class="header-cell center w5"
              v-on:click="sortFunction('twDateWeb')">
              TW Time Web
            </th>

            <th
              class="header-cell center w5"
              v-on:click="sortFunction('weight')">
              Net Weight
            </th>
            <th
              class="header-cell center w5"
              v-on:click="sortFunction('totalHours')">
              Waiting Time
            </th>
            <th
              class="header-cell center w5"
              v-on:click="sortFunction('twYgNo')">
              TW-YG No.
            </th>
            <th
              class="header-cell center w5"
              v-on:click="sortFunction('twYgWeight')">
              TW-YG Weight
            </th>
            <th
              class="header-cell center w5"
              v-on:click="sortFunction('plasticCount')">
              Plastic Count
            </th>
            <th
              class="header-cell center w5"
              v-on:click="sortFunction('palletCount')">
              Pallet Count
            </th>
            <th
              class="header-cell center w5"
              v-on:click="sortFunction('plasticWeight')">
              Plastic Weight
            </th>
            <th
              class="header-cell center w5"
              v-on:click="sortFunction('palletWeight')">
              Pallet Weight
            </th>
            <th
              class="header-cell center w5"
              v-on:click="sortFunction('bol')">
              BOL
            </th>
            <th
              class="header-cell center w5"
              v-on:click="sortFunction('bolWT')">
              BOL Weight Ticket
            </th>
            <th
              class="header-cell center w5"
              v-on:click="sortFunction('bolGW')">
              BOL Gross Weight
            </th>
            <th
              class="header-cell center w5"
              v-on:click="sortFunction('bolTW')">
              BOL Tare Weight
            </th>
            <th
              class="header-cell center w5"
              v-on:click="sortFunction('bolNW')">
              BOL Net Weight
            </th>
            <th
              class="header-cell center w5"
              v-on:click="sortFunction('weightDifferent')">
              Weight Different
            </th>
            <th
              class="header-cell center w5"
              v-on:click="sortFunction('bales')">
              Bale Count
            </th>
            <th
              class="header-cell center w5"
              v-on:click="sortFunction('looseCount')">
              Loose Count
            </th>
            <th
              class="header-cell center w5"
              v-on:click="sortFunction('qcIssue')">
              QC Issue
            </th>
            <th
              class="header-cell center w5"
              v-on:click="sortFunction('moisture')">
              Moisture
            </th>
            <th
              class="header-cell center w5"
              v-on:click="sortFunction('upgradeSuggestion')">
              Upgrade Suggestion
            </th>
            <th
              class="header-cell center w5"
              v-on:click="sortFunction('upgradeBales')">
              Upgrade Bales
            </th>
            <th
              class="header-cell center w5"
              v-on:click="sortFunction('loadRemark')">
              Remark
            </th>
           
            <th
              class="header-cell center w3"
              v-on:click="sortFunction('sapStatus')">
              SAP Status
            </th>

            <th
              class="header-cell center w5"
              v-on:click="sortFunction('unloadInfo')"
              >
              Load Start Date
            </th>

            <th
              class="header-cell center w5"
              v-on:click="sortFunction('unloadInfo')"
              >
              Load Start Time
            </th>

            <th
              class="header-cell center w5"
              v-on:click="sortFunction('unloadInfo')"
             >
              Load End Date
            </th>

            <th
              class="header-cell center w5"
              v-on:click="sortFunction('unloadInfo')"
             >
              Load End Time
            </th>

            <th
              class="header-cell center w5"
              v-on:click="sortFunction('unloadInfo')"
             >
              Load User
            </th>
              
              </thead>
            </table>
          </div>
          <div class="table-body " @scroll="handleScroll">
            <table id="bodytable">
              <tbody>
                <tr v-for="item in pageItems" v-bind:key="item.ibs">
                  <td></td>
                  <td class="body-cell excelBox w2">
                      <md-checkbox v-model="item.selected">
                        <span></span>
                      </md-checkbox>
                  </td>                 
                  <td class="body-cell excelBox w5">{{ item.ibs_type }}</td>

                  <td class="body-cell excelBox w6">{{ item.trans_yard }}</td>
                    
                  <td class="body-cell excelBox w5">{{ item.apptDate | date}}</td>

                  <td class="body-cell excelBox w5">{{ item.apptDate | time}}</td>                      
                  
                  <td class="body-cell excelBox w5">{{ item.ibs }}</td>
                  
                  <td class="body-cell excelBox w5">{{ item.ibd }}</td>
                  
                  <td class="body-cell excelBox w5">{{ item.po }}</td>
                  
                  <td class="body-cell excelBox w5">{{ item.trucker }}</td>
                  
                  <td class="body-cell excelBox w10">{{ item.trucker_name }}</td>
                  
                  <td class="body-cell excelBox w6">{{ item.po_lsd }}</td>                                          
                  
                  <td class="body-cell excelBox w5">{{ item.inco1 }}</td>
                  
                  <td class="body-cell excelBox w5">{{ item.ac }}</td>

                  <td class="body-cell excelBox w5">{{ item.ac_name }}</td>
                  
                  <td class="body-cell excelBox w5">{{ item.ibs_status }}</td>
                  
                  <td class="body-cell excelBox w5">{{ item.matnr }}</td>
                  
                  <td class="body-cell excelBox w5">{{ item.matnr_desc }}</td>
                  
                  <td class="body-cell excelBox w5">{{ item.supplier }}</td>
                  
                  <td class="body-cell excelBox w10">{{ item.supplier_name }}</td>

                  <td class="body-cell excelBox w5">{{ item.route }}</td>

                  <td class="body-cell excelBox w7">{{ item.route_desc }}</td>

                   <td class="body-cell excelBox w6">{{ item.ibs_process_DT }}</td>

                  <td class="body-cell excelBox w5">{{ item.ibs_process_TIME }}</td>
                  
                  <td class="body-cell excelBox w5">{{ item.transloadingYard }}</td>
                  
                  <td class="body-cell excelBox w5">{{ item.receivingWindows }}</td>
                  
                  <td class="body-cell excelBox w5">{{ item.dockType }}</td>

                  <td class="body-cell excelBox w5">{{ item.ibsDockType }}</td>

                  <td class="body-cell excelBox w5">{{ item.spotType }}</td>

                  <td class="body-cell excelBox w5">{{ item.apptNo }} </td>
                  
                  <td class="body-cell excelBox w5">{{ item.inboundStatus }}</td>
                  
                  <td class="body-cell excelBox w3">{{ item.block }}</td>
                  
                  <td class="body-cell excelBox w5">{{ item.workIn }}</td>
                  
                  <td class="body-cell excelBox w8">{{ item.externalTrucker }}</td>
                  
                  <td class="body-cell excelBox w6">{{ item.moveInBy }}</td>
                  
                  <td class="body-cell excelBox w5">{{ item.driverPh }}</td>
                  
                  <td class="body-cell excelBox w5">{{ item.driverLP }}</td>
                  
                  <td class="body-cell excelBox w5">{{ item.containerNo }}</td>
                  
                  <td class="body-cell excelBox w5">{{ item.ciDate | date }}</td>
                  
                  <td class="body-cell excelBox w5">{{ item.ciDate | time }}</td>
                  
                  <td class="body-cell excelBox w5">{{ item.scaleCalled }}</td>
                  
                  <td class="body-cell excelBox w5">{{ item.callTime | time }}</td>
                  
                  <td class="body-cell excelBox w5">{{ item.gwStation }}</td>
                  
                  <td class="body-cell excelBox w7">{{ item.scaleTicket }}</td>
                  
                  <td class="body-cell excelBox w7">{{ item.scanWt }}</td>

                  <td class="body-cell excelBox w7">{{ getWtForSAP(item) }}</td>

                  <td class="body-cell excelBox w5">{{ item.vgmWeight }}</td>
 
                  <td class="body-cell excelBox w5">{{ item.gwDate | date }}</td>
                  <td class="body-cell excelBox w5">{{ item.gwDate | time }}</td>
                  <td class="body-cell excelBox w5">{{ item.gwDateWeb | date }}</td>                
                  <td class="body-cell excelBox w5">{{ item.gwDateWeb | time }}</td>
                 
                  <td class="body-cell excelBox w5">{{ item.gwYgNo }}</td>
                 
                  <td class="body-cell excelBox w5">{{ item.gwYgWeight }}</td>
                 
                  <td class="body-cell excelBox w5">{{ item.twStation }} </td>      

                  <td class="body-cell excelBox w5">{{ item.tareWeight }} </td>  
                  <td class="body-cell excelBox w5">{{ item.twDate | date }}</td>               
                  <td class="body-cell excelBox w5">{{ item.twDate | time }}</td>
                  <td class="body-cell excelBox w5">{{ item.twDateWeb | date }}</td>
                  <td class="body-cell excelBox w5">{{ item.twDateWeb | time }}</td>

                  <td class="body-cell excelBox w5">{{ item.weight }}</td>
                  
                  <td class="body-cell excelBox w5">{{ item.totalHours }}</td>
                  
                  <td class="body-cell excelBox w5">{{ item.twYgNo }}</td>
                  
                  <td class="body-cell excelBox w5">{{ item.twYgWeight }} </td>
                  
                  <td class="body-cell excelBox w5">{{ item.plasticCount }}</td>
                  
                  <td class="body-cell excelBox w5">{{ item.palletCount }}</td>
                  
                  <td class="body-cell excelBox w5">{{ item.plasticWeight }}</td>
                  
                  <td class="body-cell excelBox w5">{{ item.palletWeight }}</td>
                  
                  <td class="body-cell excelBox w5">{{ item.bol }}</td>
                  
                  <td class="body-cell excelBox w5">{{ item.bolWT }}</td>

                  <td class="body-cell excelBox w5">{{ item.bolGW }}</td>
                  
                  <td class="body-cell excelBox w5">{{ item.bolTW }}</td>
                  
                  <td class="body-cell excelBox w5">{{ item.bolNW }}</td>
                  
                  <td class="body-cell excelBox w5">{{ item.weightDifferent }}</td>

                  <td class="body-cell excelBox w5">{{ item.bales }}</td>
                  
                  <td class="body-cell excelBox w5">{{ item.looseCount }}</td>
                  
                  <td class="body-cell excelBox w5">{{ item.qcIssue }}</td>

                  <td class="body-cell excelBox w5">{{ item.moisture }}</td>
                  
                  <td class="body-cell excelBox w5">{{ item.upgradeSuggestion }}</td>
                  
                  <td class="body-cell excelBox w5">{{ item.upgradeBales }}</td>
                  
                  <td class="body-cell excelBox w5">{{ item.loadRemark }}</td>

                  <td class="body-cell excelBox w3">{{ item.sapStatus}}</td>

                  <td class="body-cell excelBox w5">{{ item.unloadStartTimeStamp | date }}</td>

                  <td class="body-cell excelBox w5">{{ item.unloadStartTimeStamp | time }}</td>

                  <td class="body-cell excelBox w5">{{ item.unloadEndTimeStamp | date}}</td>

                  <td class="body-cell excelBox w5">{{ item.unloadEndTimeStamp | time}}</td>

                  <td class="body-cell excelBox w5">{{ item.uploadMobileUser }}</td>

              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </md-card>
  </template>
</pagination>
<div id="dropdown" class="dropdown-content-edit" v-if="showEditDropDown">
         <a href="#" id="dd_li" @click="doIBSUpdate" :disabled="!canEdit || (this.getPermission.fsireadonly.view && !this.getPermission.fsireadonly.edit) || this.getPermission.fsireadonlywithwgtticket.view || this.getPermission.stcAcct.view">Change</a> 
         <a href="#" @click="doIBSCopy" :disabled="!canEdit || (this.getPermission.fsireadonly.view && !this.getPermission.fsireadonly.edit) || this.getPermission.fsireadonlywithwgtticket.view || this.getPermission.stcAcct.view || this.getPermission.stcloadlistupdate.view">Copy</a>
         <a href="#" @click="doIBSDelete" :disabled="!canEdit || (this.getPermission.fsireadonly.view && !this.getPermission.fsireadonly.edit) || this.getPermission.fsireadonlywithwgtticket.view || this.getPermission.stcAcct.view || this.getPermission.stcloadlistupdate.view">Delete</a>
</div>
</div>
</template>


<style scoped>
@import '../../public/chris.css';
.excelBox {
  padding-top: 15px;
  padding-bottom: 15px;
  padding-left: 5px;
  padding-right: 5px;
  text-align: center;
}
.material-icons.md-18 { font-size: 18px; }
.material-icons.md-24 { font-size: 24px; }
.material-icons.md-36 { font-size: 36px; }
.material-icons.md-48 { font-size: 100px; }
.material-icons.md-light { color: rgba(255, 255, 255, 1); }
.material-icons.md-light.md-inactive { color: rgba(255, 255, 255, 0.3); }
.icons-center {
  vertical-align: middle;
  margin-right: 10px;
}
.inputBox {
  border: 1px solid #cacbcc;
  border-radius: 5px;
  color: #29303b;
  font-size: 18px;
  height: auto;
  line-height: 1.5em;
  padding: 5px 5px 5px 5px;
  margin-top: 5px;
}
.inputBox:hover {
  border: 2px solid #448aff;
  border-radius: 5px;
  color: #29303b;
  font-size: 18px;
  height: auto;
  line-height: 1.5em;
  padding: 6px 6px 6px 6px;
  margin-top: 5px;
  background-color: #e0eff7;
  
}
/* .selected {
 background: #726a95;
} */
.tableW {
  height: 40px;
}
.center {
  text-align: center;
}
tr:hover {
  background: #c8e6f5;
}
.headerCenter {
  text-align: center;
}
.modal {
  background-color: #29303b;
  border-radius: 5px;
}
.modalTitle {
  font-weight: normal;
  font-family: 'UberMove', 'Open Sans', 'Helvetica Neue', Helvetica, sans-serif !important;
  font-weight: 500;
  color: white;
  font-family: Poppins, sans-serif;
  margin-bottom: 0.5rem;
  line-height: 1.6;
}
.md-menu {
  padding: 0;
  padding: 0;
}
.custButton {
  margin: 10px;
  width: 120px;
  height: 40px;
  line-height:40px;
  font-size: 0.8rem;
}
.custMenuButton {
  width: 110px;
  height: 40px;
  line-height:45px;
  font-size: 0.9rem;
  align-self: center;
}
.custButtonRight {
  margin: 3px;
  width: 300px;
  height: 40px;
  float: right;
}
.custButtonFilter{
  margin: 5px;
  width: 80px ;
  height: 30px ;
  font-size: 0.7rem ;
}
.custButtonFilterRight {
  margin: 5px;
  width: 200PX;
  height: 40px;
  float: right;
}
.inputBoxSpace {
  border: 1px solid #cacbcc;
  border-radius: 5px;
  color: #29303b;
  font-size: 18px;
  height: auto;
  width: 200px;
  line-height: 1em;
  padding: 5px 5px 5px 5px;
  margin-top: 6px;
}
.inputBoxDouble {
  width: 400px;
  justify-content: space-around;
  display: flex;
  flex-direction: row;
}
.inputBoxSpaceWide {
  border: 1px solid #cacbcc;
  border-radius: 5px;
  color: #29303b;
  font-size: 18px;
  height: auto;
  width: 400px;
  line-height: 1em;
  padding: 5px 5px 5px 5px;
  margin-top: 6px;
}
.result-included-outter-div {
  border: 1px solid #D0D0D0;
  border-radius: 5px;
  width: auto;
  padding: 10px;
  height: auto;
  margin-top: 5px;
  margin-bottom: 5px;
  margin-left: 20px;
}
.result-included-inner-div {
  margin-left: 5px;
  font-weight: bold;
  margin-bottom: -25px;
}
.result-included-div-span {
  margin-left: 100px; 
  margin-top: -10px;
}
.result-included-span {
  margin-left: 5px;
}

.result-included-inner-div-radio {
  margin-left: 5px;
  margin-bottom: -25px;
  margin: -12px;
}
.result-included-span-radio {
  font-weight: bold;
  margin-left: 12px;
  margin-right: 12px;
  position:relative;
  top: -5px;
}

.dropdown {
  position: relative;
  display: inline-block;
}

/* Dropdown Content (Hidden by Default) */
.dropdown-content {
  /*display: none;*/
  position: absolute;
  /*position: relative;*/
  /*position: relative;*/
  /*position: fixed;*/
  background-color: #f1f1f1;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  /*z-index: -1;*/
  margin-top: -39px;
  margin-left: 450px;
  z-index: 1000;
}

/* Links inside the dropdown */
.dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;

}

.dropdown-content-edit {
  /*display: none;*/
  position: absolute;
  /*position: relative;*/
  /*position: relative;*/
  /*position: fixed;*/
  background-color: #f1f1f1;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  /*z-index: -1;*/
  margin-top: -35px;
  margin-left: 150px;
  z-index: 1000;
}

/* Links inside the dropdown */
.dropdown-content-edit a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;

}

.dropdown-content-edit a:hover {background-color: #ddd;}

</style>

<script>
/* eslint-disable no-plusplus */
import { mapGetters } from 'vuex';
import dateFormat from '../utils/dateFormat';
//import api from "../api";
import { newAPIPost } from '../api';
import parseXls from "../utils/parseXls";
import callingApiCenter from "../components/CallingApiCenter.vue";
import sort from "fast-sort";
import toGenerateExcelRequest, { downloadExcel } from "../utils/excel";
import IbsForm from '../components/FSIThirdPartyIBSForm.vue';
const uploadCols = [
    'ibsType',
    'transloadYard',
    'receivingWindow',
    'releaseNumber',
    'poLastDeliveryDate',
    'material',
    'poNumber',
    'inco1',
    'ibd',
    'trucker',
    'truckName',
    'acName',
    'supplier',
    'supplierName',
  ];
const getInitSearch = () => ({
  apptDate: {
    startDate: null,
    endDate: null,
  },
  ibs : null,
  po: null,
  ibd: null,
  ibs_process_DT: {
    startDate:  moment().subtract(1,'months').startOf('d').toDate(),
    endDate: moment().endOf('d').toDate(),
  },
  po_lsd: {
    startDate: null,
    endDate: null,
  },
  ibs_types: [],
  inboundStatus: null,
  dockType: null,
  scaleTicket: null,
  moveInBy: null,
  supplier_name: null,
  bol: null,
  trucker_name: null,
  matnr_desc: null,
  qcIssue: null,
  ciDate: null,
  weightDifferent: null,
  receivingWindows: null,
  transloadingYard: null,
  //only3rdParty: true,
  only3rdParty: null,
});


export default {
  data: () => ({
    searchRequest: getInitSearch(),
    active: true,
    isFilterModalShowing:false,
    ibsinbound: [],
    items:[],
    filtersapStatus_x: true,
    filtersapStatus_null: true,
    selectapptDate: "apptDate_null",
    searchtermFilter: "",
    recWindows: [],
    showEditDropDown: true,
    hasSearch: false,
}),
components: {
  callingApiCenter,
  IbsForm
},
watch: {
  getibsInbound(val) {
    this.updateibsInbound(val);
  },
},
computed: {
  ...mapGetters([
    'getPermission',
    'getUserProfile',
    'getRole',
    'getibsInbound',
    'getMasterDataName',
    'getMasterDataByGroup',
    'getMasterDataAsSelectOptionByGroup',
  ]),
  getSelectedItems() {
     var items = this.checkboxFilter.filter((row) => {
        const term = this.searchtermFilter.toUpperCase().trim();
        return (
          this.includeNull(row.ibs).includes(term) ||
          this.includeNull(row.ibd).includes(term) ||
          this.includeNull(row.po).includes(term) ||
          this.includeNull(row.apptNo).includes(term) ||
          this.includeNull(row.scaleTicket).includes(term) ||
          this.includeNull(row.inboundShipment).includes(term)
        );
      });
      this.items = items;  
        return _(this.items)
          .filter(it => it.selected);
      },  
  getibsToDisplay() {
    return this.checkboxFilter.filter((row) => {
        console.log(`first row: ${JSON.stringify(row)}`);
        const term = this.searchtermFilter.toUpperCase().trim();
        return (
          (this.includeNull(row.ibs).includes(term) ||
          this.includeNull(row.ibd).includes(term) ||
          this.includeNull(row.po).includes(term) ||
          this.includeNull(row.apptNo).includes(term) ||
          this.includeNull(row.scaleTicket).includes(term) ||
          this.includeNull(row.inboundShipment).includes(term)) &&
          (row.receivingWindows == '187' ||
           row.receivingWindows == '188')
        );
      });
    },  
  getDownloadCond() {
       return this.ibsinbound.length > 0;
    },
  checkboxFilter(){
   
    if (this.filtersapStatus_x === true && this.filtersapStatus_null === false){
         return  _(this.ibsinbound).filter(it => it.sapStatus == 'X');
    }
    if (this.filtersapStatus_null === true && this.filtersapStatus_x === false){
        return  _(this.ibsinbound).filter(it => it.sapStatus == null);
    }
   
    else
    {
      return this.ibsinbound;
    }
    },
},
async mounted() {
  const cachedSearchRequest = this.searchRequest;
  this.recWindows = this.getMasterDataAsSelectOptionByGroup('REC_WINDOW');
  if (this.recWindows.length == 0)
  {
    //this.recWindows = await api.post('/api/w/masterData',
    this.recWindows = await newAPIPost('/api/w/masterData',
             {groups: 'REC_WINDOW'  }
            );    
  }
  this.recWindows = _(this.recWindows).filter(it => it.extTrucker == '3RDPARTY');
  console.log("recwindows: " + JSON.stringify(this.recWindows));
  if (cachedSearchRequest && !_(cachedSearchRequest).isEmpty()) {
    this.searchRequest = JSON.parse(JSON.stringify(cachedSearchRequest));
  } else {
   this.searchRequest = getInitSearch(this);
  }
  this.showEditDropDown = false;
  this.hasSearch = false;
},
 methods: {
    handleStatusChanged(id) {
      this.searchRequest.inboundStatus = id;
   },
    handleCarrierChanged(id) {
      this.searchRequest.carrier = id;
    },
    // handleWindowsChanged(id) {
    //   this.searchRequest.receivingWindows = id;
    // },
    handleDockChanged(id) {
      this.searchRequest.dockType = id;
    },
    handleRecWindowChanged(id) {
      this.searchRequest.receivingWindows = id;
      console.log("rec win: " + this.searchRequest.receivingWindows + ", id: " + id);
    },
    mouseOver: function(){
      this.active = true;
    },
    mouseLeave: function() {
      this.active = !this.active;
    },
    updateibsInbound(ibsinbound) {
      var items = JSON.parse(JSON.stringify(ibsinbound));
      
      if( this.selectapptDate == "apptDate_null"){
        this.ibsinbound = items.filter(it => it.apptDate == null)
      }
      else{
        this.ibsinbound = items;
      }
    },

    doSearch() {
    this.active = false;
    
    console.log("searchRadio:" + this.selectapptDate)

    if (this.selectapptDate == "apptDate" && this.searchRequest.apptDate.startDate == null ){
       
      if ( (this.searchRequest.ibs == null || this.searchRequest.ibs == "") &&
          ( this.searchRequest.ibd == null || this.searchRequest.ibd == "") && 
          ( this.searchRequest.po == null || this.searchRequest.po == "" ) )
        {   
        this.$buefy.notification.open({
                    duration: 5000,
                    message: `apptDate is requirement field!`,
                    position: 'is-top-right',
                    type: 'is-danger',
                    hasIcon: true
                })
        return
      }}

    if (this.selectapptDate == "apptDate_null" && this.searchRequest.ibs_process_DT.startDate == null )
      {
        this.$buefy.notification.open({
                    duration: 5000,
                    message: `IBS process date is requirement field!`,
                    position: 'is-top-right',
                    type: 'is-danger',
                    hasIcon: true
                })
        return
    }

    if (this.selectapptDate == "apptDate_null" && this.searchRequest.apptDate.startDate != null )
      {
        this.$buefy.notification.open({
                    duration: 5000,
                    message: `Please don't enter appointment date!`,
                    position: 'is-top-right',
                    type: 'is-danger',
                    hasIcon: true
                })
        return
    }

    if (this.searchRequest.receivingWindows == null)
    {
       //this.searchRequest.only3rdParty = true;
       this.searchRequest.only3rdParty = "X";
    }
    else
    {
       //this.searchRequest.only3rdParty = false;
       this.searchRequest.only3rdParty = "";
    }

    this.$nextTick(() => {
      this.$store.dispatch('ibsInboundsList', this.searchRequest);
    })
    this.hasSearch = true;
    },

    doClear() {
    this.$nextTick(() => {
      this.searchRequest = getInitSearch();
    });
    },
    filterBar(){
      this.isFilterModalShowing = true;
    },
    handleScroll(e) {
       $(this.$el.querySelector('.table-header'))
       .offset({
          left: -1 * (e.target.scrollLeft - $('.outer-container')
           .offset().left),
      });
    },
    includeNull(field) {
      return field == null ? "" : field;
    },
    sortFunction(sortFiled){
      const sorted = sort(this.ibsinbound).asc(sortFiled);
      this.sortStatus = !this.sortStatus;
      console.log(this.sortStatus)
      console.log(this.ibsinbound)
    if (this.sortStatus)
      {
        this.items = sorted;
      }
    else
      {
      this.items = sorted.reverse();
    }
            
    },

    canEdit() {
        return this.getSelectedItems.length === 1 ;
    },

    getWtForSAP(item) {
       if (item.scanWt == null || item.scanWt == "") {
          return item.scaleTicket;
       } else {
          return item.scanWt;
       }
    },

    onSelectappt() {

      console.log("select:" + this.selectapptDate);
      if(this.selectapptDate == "apptDate"){

        this.searchRequest.apptDate.startDate = moment().subtract(1,'months').startOf('d').toDate();
        this.searchRequest.apptDate.endDate = moment().endOf('d').toDate();
        this.searchRequest.ibs_process_DT.startDate = null;
        this.searchRequest.ibs_process_DT.endDate = null;
        this.$refs.refibsprocessDateF.querySelector('button.md-clear').click();
        this.$refs.refibsprocessDateT.querySelector('button.md-clear').click();

      }
      else{
        console.log("selectapptDate_null");

        this.searchRequest.ibs_process_DT.startDate = moment().subtract(1,'months').startOf('d').toDate();
        this.searchRequest.ibs_process_DT.endDate = moment().endOf('d').toDate();
        this.searchRequest.apptDate.startDate = null;
        this.searchRequest.apptDate.endDate = null;
        this.$refs.refapptDateF.querySelector('button.md-clear').click();
        this.$refs.refapptDateT.querySelector('button.md-clear').click();

      }
    },

    doDownloadExcel(){
       const request = toGenerateExcelRequest(
          this.$el.querySelector('.data-table-container .inner-container'),
          'IBSInboundList.xls',
          1,
        );
        //console.log("request heads: " + JSON.stringify(request.heads));
        //console.log("item to be matched: " + JSON.stringify(item));
        request.heads = _(request.heads).take(request.heads.length);
        request.rows = _(this.getibsToDisplay)
        .map(item => [
            item.ibs_type,
            item.trans_yard,
            dateFormat.date(item.apptDate),
            dateFormat.time(item.apptDate),
            item.ibs,
            item.ibd,
            item.po,
            item.trucker,
            item.trucker_name,
            item.po_lsd,
            item.inco1,
            item.ac,
            item.ac_name,
            item.ibs_status,
            item.matnr,
            item.matnr_desc,
            item.supplier,
            item.supplier_name,
            item.route,
            item.route_desc,
            item.ibs_process_DT,
            item.ibs_process_TIME,
            item.transloadingYard,
            item.receivingWindows,
            item.dockType,
            item.ibsDockType,
            item.spotType,
            item.apptNo,
            item.inboundStatus,
            item.block,
            item.workIn,
            item.externalTrucker,
            item.moveInBy,
            item.driverPh,
            item.driverLP,
            item.containerNo,        
            dateFormat.date(item.ciDate),
            dateFormat.time(item.ciDate),
            item.scaleCalled,
            dateFormat.time(item.callTime), 
            item.gwStation, 
            item.scaleTicket,
            item.scanWt,
            item.scanWt == null ? item.scaleTicket : item.scanWt,
            item.vgmWeight,
            dateFormat.date(item.gwDate),
            dateFormat.time(item.gwDate),
            dateFormat.date(item.gwDateWeb),
            dateFormat.time(item.gwDateWeb),
            item.gwYgNo,
            item.gwYgWeight,
            item.twStation,
            item.tareWeight,
            dateFormat.date(item.twDate),
            dateFormat.time(item.twDate),
            dateFormat.date(item.twDateWeb),
            dateFormat.time(item.twDateWeb),
            item.weight,
            item.totalHours,
            item.twYgNo,
            item.twYgWeight,
            item.plasticCount,
            item.palletCount,
            item.plasticWeight,
            item.palletWeight,                                     
            item.bol,
            item.bolWT,
            item.bolGW,
            item.bolTW,
            item.bolNW,
            item.weightDifferent,
            item.bales,
            item.looseCount,
            item.qcIssue,
            item.moisture,
            item.upgradeSuggestion,
            item.upgradeBales,
            item.loadRemark,
            item.sapStatus,
            dateFormat.date(item.unloadStartTimeStamp),
            dateFormat.time(item.unloadStartTimeStamp),
            dateFormat.date(item.unloadEndTimeStamp),
            dateFormat.time(item.unloadEndTimeStamp),
            item.uploadMobileUser,
          ]);
        this.$store.dispatch('generateExcel', request)
          .then((res) => {
            window.open(res.url, 'blank');
      });
    },

    doIBSUpdate(){
        this.showEditDropDown = false;
        if (this.getSelectedItems.length == 0)
        {
          alert("Please select an item to process");
          return;
        }
        console.log("selectedItem length: " + this.getSelectedItems.length);
        const selectedItem = this.getSelectedItems[0];
        this.$refs.UpdateForm.openDialog(selectedItem);
    },

    doIBSCopy(){
        this.showEditDropDown = false; 
        if (this.getSelectedItems.length == 0)
        {
          alert("Please select an item to process");
          return;
        }
        const selectedItem = this.getSelectedItems[0];
        this.$refs.CopyForm.openDialog(selectedItem);
    },

    doIBSDelete(){
        this.showEditDropDown = false;
        if (this.getSelectedItems.length == 0)
        {
          alert("Please select an item to process");
          return;
        }
        const selectedItem = this.getSelectedItems[0];
        this.$refs.DeleteForm.openDialog(selectedItem);
    },

    doIBSCreate() {
        this.$refs.CreateForm.openDialog();
    },

    async onRefresh(item, mode){
        this.notification =  null;
        
        switch(mode) {
            case 'create':
              this.notification = `Item with IBS# ${item} has been created!`;
              break;
            case 'copy':
              this.notification = `Item with IBS# ${item} has been created!`;
              break;

            case 'update':
              this.notification = `Item with IBS# ID ${item} has been udpated!`;
              break;
            case 'delete':
              this.notification = `Item with IBS# ID ${item} has been deleted!`;
              break;
            

          }

          this.doSearch();


        
      },

      doDropDown(catalog) {
          if (catalog == "edit")
          {
             if (this.hasSearch)
             {
                this.showEditDropDown = !this.showEditDropDown;
             }
             else {
                alert("Please ensure there has IBS info to process!");
             }
          }
          if (catalog == "download")
          {
              this.showDownloadDropDown = !this.showDownloadDropDown;
          }
          if (catalog == "urgent")
          {
              this.showUrgentDropDown = !this.showUrgentDropDown;
          }
      }, 
  

    doUpload() {
        this.$el.querySelector('#upload-load-list')
          .click();
      },

    handleUploadApplicationFileSelected(e) {
        const { files } = e.target;
        if (files && files[0]) {
          parseXls(files[0])
            .then((data) => {
              const headCols = data[0];
              console.log("headCols: " + JSON.stringify(headCols));
              console.log("uploadCols: " + JSON.stringify(uploadCols));
              if (!_.isEqual(headCols, uploadCols)) {
                window.alert('Not a valid format, please download most recent template!');
                return;
              }
              headCols.push('upload result');
              data.shift();
              //console.log(JSON.stringify(data));
              this.$el.querySelector('#upload-load-list').value = '';
              const allApiCalls = _(data)
                .chain()
                .map((it) => {
                  while (it.length < uploadCols.length) {
                    it.push(null);
                  }
                  let i = 0;
                  return new Promise((resolve) => {
                    //api.post(
                    newAPIPost(
                      '/api/w/fsi/WebUploadNonfsiibs',
                      {
                        ibsType: it[i] == null ? it[i++] : it[i++],
                        transloadYard: it[i] == null ? it[i++] : it[i++].toUpperCase(),
                        receivingWindow: it[i] == null ? it[i++] : it[i++].toUpperCase(),
                        releaseNumber: it[i] == null ? it[i++] : it[i++].toUpperCase(),
                        poLastDeliveryDate: it[i] == null ? it[i++] : it[i++],
                        material: it[i] == null ? it[i++] : it[i++].toUpperCase(),
                        poNumber: it[i] == null ? it[i++] : it[i++].toUpperCase(),
                        inco1: it[i] == null ? it[i++] : it[i++].toUpperCase(),
                        ibd: it[i] == null ? it[i++] : it[i++].toUpperCase(),
                        trucker: it[i] == null ? it[i++] : it[i++].toUpperCase(),
                        truckName: it[i] == null ? it[i++] : it[i++].toUpperCase(),
                        acName: it[i] == null ? it[i++] : it[i++].toUpperCase(),
                        supplier: it[i] == null ? it[i++] : it[i++].toUpperCase(),
                        supplierName: it[i] == null ? it[i++] : it[i++].toUpperCase(),
                        //createdBy: this.getUserProfile.username,
                        processUser: this.getUserProfile.username,
                        mode: 'CREATE'
                      },
                    )
                      .then((data) => {
                        it.push(data);
                        resolve(it);
                      })
                      .catch((err) => {
                        it.push(err.messages.join(';'));
                        resolve(it);
                      });
                  });
                })
                .value();

              Promise.all(allApiCalls)
                .then((results) => {
                  const resultData = [];
                  resultData.push(headCols);
                  _(results)
                    .each(it => resultData.push(it));

                  downloadExcel(
                    resultData,
                    'Load_List',
                    'LoadList-UploadResult.xlsx',
                  );
                });
            });
        }
      },    
  }
}
</script>